import { render } from "./Htabbar.vue?vue&type=template&id=1095bb75&scoped=true"
import script from "./Htabbar.vue?vue&type=script&lang=js"
export * from "./Htabbar.vue?vue&type=script&lang=js"

import "./Htabbar.vue?vue&type=style&index=0&id=1095bb75&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1095bb75"]])

export default __exports__